import React from 'react';
import i18next from 'i18next';
import DocumentList from '../../StyledComponents/DocumentList';
import { H2, H3 } from '../../StyledComponents/Heading';
import { ProductPageMainSection } from '../../StyledComponents/ProductPage';
import { Repeat } from '../../StyledComponents/Repeat';
import { Scalars } from '../../@types/codegen/types';
import ExtendContent from '../../StyledComponents/ExtendContent';

const Translation = {
  'tyre-label': i18next.t('item.documentTypes.tireEnergyDeclaration'),
  'content declaration': i18next.t('item.documentTypes.goodsDeclaration'),
  other: i18next.t('item.documentTypes.other'),
};

const SortOrder = {
  'tyre-label': 2,
  'content declaration': 1,
  other: 3,
};

type CategoryType = keyof typeof Translation;

interface DocumentCategory {
  category: string;
  sortOrder: number;
  documents: Scalars['FileDocument']['output'][];
}

interface DocumentsProps {
  documents: Scalars['FileDocument']['output'][];
}

const Documents = ({ documents }: DocumentsProps) => {
  const categorised = documents
    .reduce((prev, curr) => {
      const index = prev.findIndex((x) => x.category === (curr.category || 'others'));
      if (index > -1) {
        prev[index].documents.push(curr);
      } else {
        const category = curr.category || 'others';
        prev.push({
          category,
          documents: [curr],
          sortOrder: SortOrder?.[category as CategoryType] ?? 99,
        });
      }

      return prev;
    }, [] as DocumentCategory[])
    .sort((a, b) => a.sortOrder - b.sortOrder);

  if (!documents.length) return null;

  const manyCategories = categorised.length > 1;

  return (
    <ProductPageMainSection>
      <Repeat>
        <H2 noMargin>{i18next.t('item.documents')}</H2>
      </Repeat>
      <Repeat>
        <ExtendContent actionTitle={i18next.t('common.showMore')}>
          {categorised.map((group) => (
            <Repeat key={group.category}>
              {manyCategories && (
                <H3>{Translation?.[group.category as CategoryType] || Translation.other}</H3>
              )}
              <DocumentList documents={group.documents} />
            </Repeat>
          ))}
        </ExtendContent>
      </Repeat>
    </ProductPageMainSection>
  );
};

export default Documents;
